import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import Datetime from "react-datetime";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Badge from "beaktShared/components/Badge/Badge.js";

// icons
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Search from "@material-ui/icons/Search";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { formateDate, formateDateandTime, validateDate, convertDate, transformValueFloattoFormated,transformValueFormatedtoFloat, MaskMoney, MaskDate, getLocale, getStringFormatDate} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


export default function GestaoPedidoCompra() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();    

    const { register, setValue, errors, setError, clearError, getValues, handleSubmit } = useForm({mode: "onChange"});
    const [loading,setloading] = React.useState(false);
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo==='error'?true:false}
          warning={tipo==='warning'?true:false}
          success={tipo==='success'?true:false}

          title={t('label.warning')}
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };
    
    
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        let todos = {
            estabelecimentoId: 0,
            descricao: "Todos"
        };

        let lista_estabelecimentos = [todos, ...result.data];

        setisLoadingEstabelecimento(false);
        setestabelecimentos(lista_estabelecimentos);
        return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-90, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    useEffect(() => {      
        if (session.estabelecimentoId === 0)
            LoadEstabelecimentos();
        else
            setestabelecimento(session.estabelecimentoId);

    }, []);

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    const [list, setlist] = React.useState([]);
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (estabelecimento === "")
            estabelecimento = 0;

        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate",t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate",t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida =convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }        

        setloading(true);

        let obj = {
            estabelecimentoId: estabelecimento,
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida,            
        }

        const endPoint = "pedidocompra/GetPedidosByEstabelecimentoPeriodo/";
        UsePostApi(endPoint,obj).then(result=>{    
            setloading(false);
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')                
                return false; 
            }    
            setlist(result.data);            
            return true;                
        }); 
    };

    const [showModal, setshowModal] = React.useState(false);
    const [detalheCompra,setdetalheCompra] = React.useState([]);
    const handleDetalhe = (row) =>{        
        setdetalheCompra(row);
        setshowModal(true);
    }
    
    const changeQtdSeparacao = (e, pedidoCompraItemId) => {
        let newList = []
        let pedido = detalheCompra;
        let item = pedido.pedidoCompraItens.filter(f => f.pedidoCompraItemId === pedidoCompraItemId)[0];
        item.quantidadeEnviada = parseInt(e.target.value);
        newList = pedido.pedidoCompraItens.map(p => (p.pedidoCompraItemId === pedidoCompraItemId ? item : p));        
        pedido.pedidoCompraItens = newList;
        setdetalheCompra(pedido);
    };

    const confirmarSeparacao = () => {
        if (detalheCompra.pedidoCompraItens.filter(f => (f.quantidadeEnviada === null || f.quantidadeEnviada < 0)).length > 0){
            showAlert(t('error_message.enter_separate_quantity_for_product'), "warning");
            return;
        }
        detalheCompra.usuarioSeparacaoId = session.id
        
        setloading(true);
        UsePutApi("pedidocompra/ConfirmarSeparacaoEstoque", '', detalheCompra).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            t('error_message.enter_separate_quantity_for_product')
            showAlert(t('stock.separation_successfully'), "success");
            return true;
        });
    }

    const estornarSeparacao = () => {
        UsePutApi("pedidocompra/EstornarSeparacao/" + detalheCompra.pedidoCompraId + "/" + session.id, '', null).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            showAlert(t('stock.chargeback_successfully'), "success");
            return true;
        });
    }

    const [formaRemessa] = React.useState([
        {
            descricao: t('stock.withdrawal_at_franchise'),
            value: "Retirada"
        },
        {
            descricao: t('stock.dispatch_to_the_clinic'),
            value: "Expedicao"
        }
    ]);
    const [remessa, setremessa] = React.useState(0);
    const handleRemessaChange = event => {
        let value = event
        setremessa(value);
        setValue("formaremessa", value);
        if (value !== "")
            clearError("formaremessa");
    };

    const onSubmit = (data, e) => {        
        e.preventDefault();

        if (data.notafiscal === ''){
            return setError("notafiscal", "required");               
        }

        if (data.dataexpedicao.length !== 10){
            return setError("dataexpedicao", "required");
        }

        if (remessa === "" || remessa === 0){
            return setError("formaremessa", "required");               
        }
        
        var dataexpedicao_date = convertDate(data.dataexpedicao);

        detalheCompra.documento = data.notafiscal;
        detalheCompra.usuarioExpedicaoId = session.id;
        detalheCompra.dataExpedicao = dataexpedicao_date;
        detalheCompra.tiporemessa = remessa;
        detalheCompra.valorDespesaRemessa = transformValueFormatedtoFloat(data.valordespesa);
        detalheCompra.codigoRastreio = data.codigorastreio;

        setloading(true);
        
        UsePutApi("pedidocompra/ConfirmarExpedicao", '', detalheCompra).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            showAlert(t('stock.expedition_successfully'), "success");
            return true;
        });
    }

    const estornarExpedicao = () => {
        setloading(true);
        UsePutApi("pedidocompra/EstornarExpedicao/", detalheCompra.pedidoCompraId, '').then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            showAlert(t('stock.chargeback_successfully_pending_shipment'), "success");
            return true;
        });
    }

    const confirmarRecebimento = () => {
        setloading(true);
        UsePutApi("pedidocompra/ConfirmarRecebimento/", detalheCompra.pedidoCompraId + "/" + session.id, '').then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            showAlert(t('stock.goods_receipt_successfully'), "success");
            return true;
        });
    }

    const verificarPagamento = () => {
        setloading(true);
        UsePutApi("pedidocompra/AtualizaStatusPagamento/", detalheCompra.pedidoCompraId, '').then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }           
            handleClickPesquisa(); 
            setshowModal(false);
            
            if (result.data.statusPedido === 4)                
                showAlert(t('stock.purchase_order_successfully_processing_payment'), "warning");                
            else if (result.data.statusPedido === 5)
                showAlert(t('stock.error_pay_order'), "danger");                
            else
                showAlert(t('stock.purchase_order_successfully'), "success");    
                
            return true;
        });
    }

    const columnsProps = [        
        {
            Header: t('label.establishment'),
            accessor: "estabelecimento.descricao",            
        },
        {
            Header: t('sidebar.order'),
            accessor: "pedidoCompraId",            
        },
        {
            Header: t('label.date'),
            accessor:"dataPedido",
            Cell : (props)=>{
                const custom_date = formateDateandTime(props.value);
                return <span>{custom_date}</span>
            }
        },        
        {
            Header: t('stock.settled'),
            accessor: "pagamentoEfetuadoDescricao"            
        },
        {
            Header: "Status",
            Cell: (row) => { 
                    let color = "success";
                    if (row.original.statusPedidoDescricao === "Pendente de Separação")
                        return <span><Badge color="warning">{t('stock.separation_pending')}</Badge></span>
                    else if (row.original.statusPedidoDescricao === "Pendente de Expedição")
                        return <span><Badge color="danger">{t('stock.pending_expedition')}</Badge></span>
                    else if (row.original.statusPedidoDescricao === "Enviado")
                        return <span><Badge color="info">{t('stock.sent')}</Badge></span>
                    else if (row.original.statusPedidoDescricao === "Recebido")
                        return <span><Badge color="success">{t('stock.received')}</Badge></span>
                    else 
                        return <span><Badge color="gray">{row.original.statusPedidoDescricao}</Badge></span>
                },
            accessor: "statusPedidoDescricao",
        },
    ]
    const columnsAcao = [        
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">              
            <Button
                justIcon round simple color="info"                 
                onClick={() => handleDetalhe(row.original)}
            > 
            <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
            <Search />
            </Tooltip>
            </Button>{" "}                          
        </div>
        ),
        sortable: false,
        filterable: false
    }
    ];

    let columns = [...columnsProps,...columnsAcao];    

    return (
        <div>                                     
            <GridContainer>
                {alert}
                {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')} ...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                }
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <ShoppingCartIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('stock.purchase_order_management')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                {session.estabelecimentoId === 0 &&
                                    <GridItem xs={12} sm={6} md={4}>                
                                        <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                            {t('label.establishment')}
                                        </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.estabelecimento ? true : false)}
                                            isSearchable={true}
                                            isLoading={isLoadingEstabelecimento}
                                            name="estabelecimento"
                                            placeholder={t('label.all')}
                                            options={estabelecimentos}
                                            value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                            onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                            ref={() => register({ name: "estabelecimento" })
                                            }
                                        />
                                        {errors.estabelecimento &&
                                        <FormHelperText>
                                            <span className="obg"> {t('label.required')} </span>
                                        </FormHelperText>}
                                        </FormControl>                    
                                    </GridItem>
                                }
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                            {t('label.ini_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtini"                                      
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtini?"error":""}            
                                        />       
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {t('label.required')} </span>                                                                          
                                        </FormHelperText>} 
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                            {t('label.end_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtfim"                                      
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtfim?"error":""}            
                                        />       
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {t('label.required')} </span>                                                                          
                                        </FormHelperText>} 
                                    </FormControl>                                                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button  round color="primary" 
                                        onClick={e => { handleClickPesquisa()}}>
                                        {t('label.search')} 
                                    </Button>
                                </GridItem>                                  
                            </GridContainer>
                            {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                />
                            </div>}

                            <ReactTable
                                loading = {loading}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>

                {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                    }

                <Dialog
                        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                        open={showModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setshowModal(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                        >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{background:'#5c4477'}}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{color:'white'}}>{t('sidebar.purchase_order')}</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody} 
                    >   
                        <div className="subTitulo" style={{marginTop:'20px'}}> 
                        <h6>{t('stock.order_details')}</h6>
                        </div>
                        <GridContainer>                            
                            <GridItem xs={12} sm={6} md={4}>
                                <label><b>{t('label.establishment')}:</b> {(detalheCompra.estabelecimento != null ? detalheCompra.estabelecimento.descricao : "")}</label>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>
                                <label><b>{t('stock.date_order')}:</b> {formateDateandTime(detalheCompra.dataPedido)}</label>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>
                                <label><b>{t('stock.user_order')}:</b> {detalheCompra.usuarioPedidoNome}</label>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>
                                <label><b>{t('stock.status_order')}:</b> {detalheCompra.statusPedidoDescricao}</label>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>
                                {(detalheCompra.statusPedidoDescricao !== "Pendente de Separação") && 
                                   <label><b>{t('stock.separation_date')}:</b> {formateDateandTime(detalheCompra.dataSeparacao)}</label>
                                }
                            </GridItem>                            
                        </GridContainer>    
                        <div className="subTitulo" style={{marginTop:'20px'}}> 
                        <h6>Informações de Pagamento</h6>
                        </div>
                        <GridContainer>
                        {detalheCompra.pedidoCOmpraPagamentoCartoes != null && detalheCompra.pedidoCOmpraPagamentoCartoes.map(item => (
                                <GridItem key={item.pedidoCompraPagamentoCartaoId} xs={12} sm={12} md={12}>
                                    <label><b>Cartão: </b>{transformValueFloattoFormated(item.valor)} em {item.parcelas}x (Autorização: {item.numAutorizacao}) </label>
                                </GridItem>
                            ))}
                            {detalheCompra.pedidoCompraPagamentoDepositos != null && detalheCompra.pedidoCompraPagamentoDepositos.map(item => (
                                <GridItem key={item.pedidoCompraPagamentoDepositoId} xs={12} sm={12} md={12}>
                                    <label><b>Depóstivo: </b>{transformValueFloattoFormated(item.valor)} </label>
                                </GridItem>
                            ))}
                        </GridContainer>                      
                        {(detalheCompra.statusPedidoDescricao !== "Pendente de Separação" && detalheCompra.statusPedidoDescricao !== "Pendente de Expedição") &&
                            <div>
                                <br/>
                                <div className="subTitulo"> 
                                    <h6>{t('stock.shipping_data')}</h6>
                                </div>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <label><b>{t('stock.shipping_date')}:</b> {formateDateandTime(detalheCompra.dataExpedicao)}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <label><b>{t('stock.document')}:</b> {detalheCompra.documento}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <label><b>{t('stock.shipping_form')}:</b> {detalheCompra.tipoRemessa}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <label><b>{t('stock.shipping_form')}:</b> {transformValueFloattoFormated(detalheCompra.valorDespesaRemessa != null ? detalheCompra.valorDespesaRemessa : 0)}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <label><b>{t('stock.tracking_code')}:</b> {detalheCompra.codigoRastreio}</label>
                                    </GridItem>
                                </GridContainer>
                            </div>
                        }        
                        <br/>                                            
                        <div className="subTitulo"> 
                            <h6>{t('stock.order_items')}</h6>
                        </div>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th>{t('label.description')}</th>
                                <th>{t('stock.requested_qty')}</th>
                                <th>{t('stock.qty_sent')}</th>
                                <th>{t('label.money_symbol')} {t('label.unitary')}</th>                                
                            </tr>
                            </thead>
                            <tbody>  
                            {detalheCompra.pedidoCompraItens && detalheCompra.pedidoCompraItens.map(item => ( 
                                <tr key={item.pedidoCompraItemId}>
                                    <td>{item.produto.descricao}</td>
                                    <td style={{textAlign:"right"}}>{item.quantidadeSolicitada}</td>
                                    <td style={{textAlign:"right"}}>{(session.estabelecimentoId === 0 && detalheCompra.statusPedidoDescricao === "Pendente de Separação") &&
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField                                                
                                                variant="outlined"
                                                type="number"
                                                name="qtdEnviada"
                                                InputLabelProps={{shrink: true}}  
                                                inputProps={{maxLength: 3}} 
                                                onChange={(e) => changeQtdSeparacao(e,item.pedidoCompraItemId)}                                                
                                            />                                                                                
                                        </FormControl>
                                        }
                                        {
                                            detalheCompra.statusPedidoDescricao !== "Pendente de Separação" && item.quantidadeEnviada
                                        }
                                    </td>
                                    <td style={{textAlign:"right"}}>{transformValueFloattoFormated(item.valorUnitario)}</td>                                    
                                </tr> ))}                               
                            </tbody>
                        </table>                                                        
                        <div>
                            <h5 style={{textAlign:"right"}}><b>{t('label.value_total')}:</b> {t('label.money_symbol')} {transformValueFloattoFormated((detalheCompra.valorTotal === null ? 0 : detalheCompra.valorTotal))}</h5>
                        </div>
                        <br/>
                        {(session.estabelecimentoId === 0 && detalheCompra.statusPedidoDescricao === "Pendente de Expedição") &&
                            <div>
                                <div className="subTitulo"> 
                                    <h6>{t('stock.shipping_data')}</h6>
                                </div>
                                <br/>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} md={4}>
                                            <FormControl fullWidth className={classes.formControl}>                               
                                                <TextField                                        
                                                    error={errors.notafiscal?true:false}
                                                    label={t('stock.chit')+" *"}
                                                    variant="outlined"
                                                    inputRef={register()}
                                                    name="notafiscal"
                                                    InputLabelProps={{shrink: true}}
                                                    inputRef={register({
                                                        required: t('label.required'),                                                    
                                                        maxLength: {
                                                            value:30,
                                                            message: t('label.enter_a_maximum_of_30_characters')
                                                        }
                                                    })}
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                {errors.notafiscal && <span className="obg">{errors.notafiscal.message}</span>}
                                                </FormHelperText>   
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <TextField
                                                    error={errors.dataexpedicao?true:false}
                                                    variant="outlined"
                                                    inputRef={register({required:true})}
                                                    label={t('stock.shipping_date')+" *"}
                                                    name="dataexpedicao"
                                                    InputLabelProps={{shrink: true}}
                                                    InputProps={{ inputComponent: MaskDate }}               
                                                />
                                                {errors.dataexpedicao && 
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.dataexpedicao && <span className="obg">{t('label.required')}</span>}
                                                </FormHelperText>   
                                                }
                                            </FormControl>
                                        </GridItem>                                
                                        <GridItem xs={12} sm={6} md={4}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.formaremessa ? "select__label select__label_error" : "select__label"}>
                                                    {t('stock.shipping_form')} * </label>
                                                <Select
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.formaremessa ? true : false)}
                                                    isSearchable={true}                                        
                                                    name="formaremessa"
                                                    placeholder={t('label.select')+"..."}
                                                    options={formaRemessa}
                                                    value={formaRemessa.filter(({ value }) => value === remessa)}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ value }) => value}                                        
                                                    onChange={(value) => handleRemessaChange(value.value !== null ? value.value : "")}
                                                    ref={() => register({ name: "formaremessa" })
                                                    }
                                                />
                                                {errors.formaremessa &&
                                                <FormHelperText>
                                                    <span className="obg"> {t('label.required')} </span>
                                                </FormHelperText>}
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4}>                
                                            {remessa === "Expedicao" &&
                                                <FormControl fullWidth className={classes.formControl}>                               
                                                    <TextField                                        
                                                        error={errors.valordespesa?true:false}
                                                        label={t('stock.expense_shipping')+" *"}
                                                        variant="outlined"
                                                        inputRef={register({required: true})}
                                                        name="valordespesa"
                                                        InputLabelProps={{shrink: true}}
                                                        InputProps={{
                                                            inputComponent: MaskMoney,                                            
                                                        }}                   
                                                    />
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.valordespesa && <span>{t('label.required')}</span>}
                                                    </FormHelperText>   
                                                </FormControl>      
                                            }                
                                        </GridItem>  
                                        <GridItem xs={12} sm={6} md={4}>                
                                            {remessa === "Expedicao" &&
                                                <FormControl fullWidth className={classes.formControl}>                               
                                                    <TextField                                                                                        
                                                        label={t('stock.tracking_code')}
                                                        variant="outlined"
                                                        inputRef={register({required: true})}
                                                        name="codigorastreio"
                                                        InputLabelProps={{shrink: true}}                                                                                                    
                                                    />
                                                </FormControl>      
                                            }                
                                        </GridItem>                                
                                    </GridContainer>
                                    <center className="no-print">
                                        <Button color="primary" type="submit">
                                            {t('stock.confirm_shipment')}
                                        </Button>
                                        <Button color="secondary" onClick={() => estornarSeparacao()}>
                                            {t('stock.reverse_separation')}
                                        </Button>
                                    </center>
                                </form>
                            </div>
                        }
                        <br/>
                        {(session.estabelecimentoId === 0 && detalheCompra.statusPedidoDescricao === "Pendente de Separação") &&
                            <center className="no-print">
                                <Button color="primary" onClick={() => confirmarSeparacao()}>
                                    {t('stock.confirm_separation')}
                                </Button>
                            </center>
                        }
                        {(session.estabelecimentoId === 0 && detalheCompra.statusPedidoDescricao === "Enviado") &&
                            <center className="no-print">
                                <Button color="secondary" onClick={() => estornarExpedicao()}>
                                    {t('stock.reverse_expedition')}
                                </Button>
                            </center>
                        }
                        {(session.estabelecimentoId !== 0 && detalheCompra.statusPedidoDescricao === "Enviado") &&
                            <center className="no-print">
                                <Button color="primary" onClick={() => confirmarRecebimento()}>
                                    {t('stock.confirm_receipt')}
                                </Button>
                            </center>
                        }
                        {(session.estabelecimentoId !== 0 && detalheCompra.statusPedidoDescricao === "Processando Pagamento") &&
                            <center className="no-print">
                                <Button color="primary" onClick={() => verificarPagamento()}>
                                    {t('stock.check_payment')}
                                </Button>
                            </center>
                        }
                        <br/>
                    </DialogContent>
                </Dialog>

            </GridContainer>                             
        </div>
    );
}